import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderAccounting, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0750. 発注案件管理会計削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_accountings/:purchase_order_accounting_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  purchase_order_accounting_id: number;
};
const destroyPurchaseOrderAccounting = (props: Props): Promise<PurchaseOrderAccounting> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_accountings/${props.purchase_order_accounting_id}`
  );
};

export const useDestroyPurchaseOrderAccounting = () => {
  return useMutation({
    mutationFn: destroyPurchaseOrderAccounting,
  });
};
